export default __webpack_public_path__ + "static/media/portagent-logo-cut.38c71a07.svg";